/**
 * WordPress dependencies.
 */
import { __, sprintf } from "@wordpress/i18n";
import { TabPanel } from "@wordpress/components";

const Headers = ({ setActive, isAtive }) => {
	const TABS = [];

	TABS.push({
		name: "general",
		title: __("General", "aruba-hispeed-cache"),
		className: "general-tab",
	});

	if (true === isAtive) {
		// TABS.push(
		// 	// {
		// 	// 	name: "custom",
		// 	// 	title: __("Customization", "aruba-hispeed-cache"),
		// 	// 	className: "custom-tab",
		// 	// },
		// 	{
		// 		name: "speed-test",
		// 		title: __("Speed Test", "aruba-hispeed-cache"),
		// 		className: "speed-test-tab",
		// 	}
		// );

		if ("true" === window.ahscUtils.const.isDebug) {
			TABS.push({
				name: "debug",
				title: __("Debug", "aruba-hispeed-cache"),
				className: "debug-tab",
			});
		}
	}

	return (
		<header class="ahsc-header">
			<div class="ahsc-container">
				<div class="ahsc-logo">
					<img
						src={window.ahscUtils.const.logosrc}
						title={__(
							"Aruba HiSpeed Cache interfaces directly with an Aruba hosting platform's HiSpeed Cache service and automates its management.",
							"aruba-hispeed-cache"
						)}
					/>

					<h1 class="title">Aruba HiSpeed Cache</h1>

					<abbr
						title={sprintf(__("Version: %s", "aruba-hispeed-cache"), window.ahscUtils.const.version)}
						class="version"
					>
						{window.ahscUtils.const.version}
					</abbr>
				</div>

				<TabPanel
					className="ahs-tab-panel"
					activeClass="ahs-active-tab"
					orientation="horizontal"
					initialTabName="general"
					//onSelect={(tab) => console.log(tab)}
					tabs={TABS}
				>
					{(tab) => setActive(tab.name)}
				</TabPanel>
			</div>
		</header>
	);
};

export default Headers;
